<template>
	<div class="iv2-closed">
		<div class="iv2-closed-block">
			<h1 class="iv2-closed-title">{{ $t('system.closed.title') }}</h1>
			<h2 class="iv2-closed-lead">{{ $t('system.closed.lead') }}</h2>
			<p class="iv2-closed-summary text-pre">{{ $t('system.closed.summary') }}</p>
		</div>
	</div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.iv2-closed {
	background-color: #efefef;
	height: 100vh;
	position: relative;

	.iv2-closed-block {
		text-align: center;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);

		.iv2-closed-title {
			font-size: 4.5rem;
		}

		.iv2-closed-lead {
			font-size: 1.5rem;
			font-weight: 600;
			padding: 2rem 1rem;
			margin: 0;
		}

		.iv2-closed-summary {
			margin: 0;
		}
	}
}

@media (max-width: 1199px) {
	.iv2-closed {
		.iv2-closed-block {
			.iv2-closed-title {
				font-size: 3rem;
			}

			.iv2-closed-lead {
				font-size: 1rem;
			}
		}
	}
}
</style>